module.exports = __webpack_public_path__ + "img/idea_img8.b422a929.png";